(function(){
    'use strict'

    angular
    .module('app.usuarios-organizador')
    .controller('CambiarPasswordUsuarioOrganizador', CambiarPasswordUsuarioOrganizador);

    CambiarPasswordUsuarioOrganizador.$inject = ['$scope', '$animationsSrv', '$routeParams', 'UsuariosOrganizadorService', 'logger', '$location', 'UserInfoService'];

    function CambiarPasswordUsuarioOrganizador($scope, $animationsSrv, $routeParams, UsuariosOrganizadorService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.usuarioId = $routeParams.id ? $routeParams.id : 0;
        vm.nombreUsuario = $routeParams.id ? $routeParams.nombre : '';

        if(vm.usuarioId == 0 || vm.nombreUsuario == ''){
            $location.path('/usuarios-organizador');
        }

        vm.save = function(){

            $scope.submitted = true;

            if($scope.cambiarPasswordForm.$valid){
                if($scope.cambiarPasswordForm.$dirty){
                    updatePassword();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
                
            }
            else{
                logger.error('Por favor corrija los datos');
            }
        
        };

        function updatePassword() {
            vm.usuario.id = vm.usuarioId;
            var promise = UsuariosOrganizadorService.changePassword(vm.usuario);
                
            promise
            .then(function(response){
                logger.success('Usuario modificado con éxito.');
                $location.path('/usuarios-organizador');
            })
            .catch(function(error){
                logger.error('Hubo un erro al modificar el usuario');
            }); 
        }

    }
})();